export default "__VITE_ASSET__CpNGoCv5__"